import Route from '@ember/routing/route';
import type PublicTransition from '@ember/routing/transition';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';

export default class DatamanagerRoute extends Route {
	@service('flow/integrations-selection-popup')
	declare flowIntegrationsSelectionPopupService: Service.Flow.IntegrationsSelectionPopup;
	@service('navigation') declare navigationService: Service.Navigation;

	override beforeModel(): Promise<unknown> {
		document.body.id = 'page-datamanager';

		return this.navigationService.initialRequestsPromise;
	}

	override afterModel(_model: unknown, transition: PublicTransition): void {
		transition.then(() => {
			this.flowIntegrationsSelectionPopupService.checkToOpenPopupWithDelay();
		});
	}
}
